// Singleton @sympllex/api-client instance for the tenant cockpit. The active session
// (set by SessionProvider) is injected as the dev session header → RLS tenant context
// on the tenant-worker. Bearer mode lands with WorkOS browser auth (C1.3). PLAN-C1.9.
import { createApiClient, type SympllexApiClient } from "@sympllex/api-client";
import type { SympllexSession } from "@sympllex/auth";
import { API_BASE } from "./env";
import { refreshSession } from "./auth";

let currentSession: SympllexSession | null = null;
export function setApiSession(s: SympllexSession | null): void { currentSession = s; }

export const api: SympllexApiClient = createApiClient({
  baseUrls: { tenant: API_BASE.tenant, admin: API_BASE.admin, mcp: API_BASE.mcp, billing: API_BASE.billing },
  // prod: rely on the first-party httpOnly session cookie (credentialed CORS). The SPA + the API
  // workers share aquinocompliance.com, so the cookie travels to every *.aquinocompliance.com worker
  // in all browsers. dev: inject the dev-session header.
  mode: import.meta.env.DEV ? "dev" : "cookie",
  getSession: () => currentSession,
  // On a 401 (expired 15-min access token) silently refresh off the 14-day session, then retry once.
  onUnauthorized: refreshSession,
});
